import { EMPTY_FUNCTION } from '../../../constants/common'

import * as styles from './SearchListItem.module.css'

/**
 * @typedef {object} SearchListItemProps
 *
 * @property {string} [Element]
 *
 * @property {React.ReactNode} [children]
 *
 * @property {string} [className]
 *
 * @property {SearchItemValue} value
 *
 * @property {(value: SearchItemValue) => void} [onSelect]
 */

/**
 * @param {SearchListItemProps} props
 */
function SearchListItem({
  Element = 'li',
  children,
  className = styles.SearchListItem,
  value,
  onSelect = EMPTY_FUNCTION,
}) {
  function handleClick() {
    onSelect(value)
  }

  return (
    <Element className={className} onClick={handleClick}>
      {children}
    </Element>
  )
}

export default SearchListItem
